import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import * as IncidentsStore from '../../../store/incidents';
import * as ProjectsStore from '../../../store/projects';
import * as CommonValuesStore from '../../../store/common-values';
import { bindActionCreators } from 'redux';
import ProjectsList from './ProjectsList';
import Loading from '../../application/Loading';
import { ConnectedRouterProps } from 'connected-react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { projectStatusOptions } from '../../../utils/utils';
import GoBackContainer from './../../application/GoBackContainer';


// At runtime, Redux will merge together...
type ProjectsListProps =
    & ProjectsStore.ProjectsState
    & typeof ProjectsStore.actionCreators
    & CommonValuesStore.CommmonValuesState
    & typeof CommonValuesStore.actionCreators
    & ConnectedRouterProps;

class ProjectsListContainer extends React.PureComponent<ProjectsListProps> {
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    private openNewForm() {
        this.props.history.push('/projects/new');
    }

    private openDetails(number: string) {
        this.props.history.push(`/projects/details/${number}`);
    }

    public render() {
        return (
            <React.Fragment>
                <GoBackContainer title="Prosjekter" onGoBack={() => this.props.history.goBack()}>
                    {this.props.isLoading ? (
                        <Loading />
                    ) : (
                            <ProjectsList projects={this.props.projects} projectStatuses={projectStatusOptions} onOpenDetails={(number) => this.openDetails(number)} onOpenNewForm={() => this.openNewForm()} />
                    )}
                </GoBackContainer>
            </React.Fragment >
        );
    }

    private ensureDataFetched() {
        this.props.requestProjects();
    }
}

export default connect(
    (state: RootState) => {
        const { projects, commonValues } = state;
        return {
            ...projects,
            ...commonValues
        };
    },
    (dispatch) => {
        return {
            ...bindActionCreators(Object.assign({}, ProjectsStore.actionCreators, CommonValuesStore.actionCreators), dispatch)
        };
    }
)(ProjectsListContainer as any); // eslint-disable-line @typescript-eslint/no-explicit-any
